/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { DcrFragmentDoc } from '../fragment/DCR.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDcrListQueryVariables = Types.Exact<{
	paginationInput: Types.PaginationInput;
	searchInput?: Types.InputMaybe<Types.SearchMyDcRsInput>;
}>;

export type GetDcrListQuery = {
	__typename?: 'Query';
	getDcrs:
		| { __typename?: 'BadRequest' }
		| {
				__typename?: 'DCRResults';
				total: number;
				statusFacets: Array<{
					__typename?: 'DCRStatusFacet';
					status: Types.DcrDisplayStatus;
					count: number;
				}>;
				results: Array<{
					__typename?: 'DCR';
					id: any;
					networkId?: string | null;
					type: Types.DcrType;
					entityType: Types.DcrEntityType;
					entityData: string;
					note?: string | null;
					displayStatus: Types.DcrDisplayStatus;
					createdAt?: any | null;
					completedAt?: any | null;
					fieldResults?: Array<{
						__typename?: 'DCRFieldResult';
						field: string;
						group: string;
						result?: Types.DcrFieldResultStatus | null;
						previousValue?: string | null;
						requestedValue?: string | null;
						finalValue?: string | null;
					}> | null;
					resolutionNotes?: Array<{
						__typename?: 'DCRResolutionNote';
						comment: string;
					}> | null;
					attachments: Array<{
						__typename?: 'DCRAttachment';
						id: any;
						fileName: string;
						fileContentType: string;
						fileSize: number;
						viewUrl: string;
					}>;
					currentEntity?:
						| {
								__typename?: 'HCO';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								hcoNameCda_V?: string | null;
								displayName_V?: string | null;
								hcoNameShort_V?: string | null;
								hcoNameEnglish_V?: string | null;
								hcoNameIntl_V?: string | null;
								hcoTypeCda_V?: string | null;
								affiliationSearch:
									| {
											__typename: 'BadRequest';
											message: string;
											errors: Array<string>;
									  }
									| {
											__typename: 'HCOAffiliationsResults';
											results: Array<{
												__typename?: 'ParentHCO';
												vid_V: string;
												relationshipType?: {
													__typename?: 'RelationshipType';
													code: string;
												} | null;
											}>;
									  };
								licenses: Array<{ __typename?: 'License'; vid_V: string }>;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
								hcoType?: {
									__typename?: 'HCOType';
									id: string;
									name: string;
								} | null;
						  }
						| {
								__typename?: 'HCP';
								countryId?: string | null;
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								firstNameCda_V?: string | null;
								firstNameIntl_V?: string | null;
								middleNameCda_V?: string | null;
								middleNameIntl_V?: string | null;
								lastNameCda_V?: string | null;
								lastNameIntl_V?: string | null;
								nickname_V?: string | null;
								prefixCda_V?: string | null;
								suffixCda_V?: string | null;
								allDegreeCda_V?: string | null;
								degree1Cda_V?: string | null;
								hcpTypeCda_V?: string | null;
								affiliationSearch:
									| {
											__typename: 'BadRequest';
											message: string;
											errors: Array<string>;
									  }
									| {
											__typename: 'HCPAffiliationsResults';
											results: Array<{
												__typename?: 'ParentHCO';
												vid_V: string;
												isPrimaryRelationship_V?: boolean | null;
												parentHco:
													| {
															__typename?: 'HCO';
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															displayName_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| {
															__typename?: 'ResourceNotFound';
															message: string;
													  };
											}>;
									  };
								licenses: Array<{ __typename?: 'License'; vid_V: string }>;
								hcpType?: {
									__typename?: 'HCPType';
									id: string;
									name: string;
									count: number;
								} | null;
								hcpSpecialties: Array<{
									__typename?: 'HCPSpecialty';
									primary: boolean;
									specialty: {
										__typename?: 'Specialty';
										id: string;
										name: string;
										specialtyGroup: {
											__typename?: 'SpecialtyGroup';
											id: string;
											name: string;
										};
									};
								}>;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
						  }
						| null;
				}>;
		  }
		| { __typename?: 'Forbidden' };
};

export const GetDcrListDocument = gql`
	query GetDCRList(
		$paginationInput: PaginationInput!
		$searchInput: SearchMyDCRsInput
	) {
		getDcrs(paginationInput: $paginationInput, searchInput: $searchInput) {
			... on DCRResults {
				total
				statusFacets {
					status
					count
				}
				results {
					...DCR
				}
			}
		}
	}
	${DcrFragmentDoc}
`;

/**
 * __useGetDcrListQuery__
 *
 * To run a query within a React component, call `useGetDcrListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDcrListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDcrListQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useGetDcrListQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetDcrListQuery,
		GetDcrListQueryVariables
	> &
		(
			| { variables: GetDcrListQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetDcrListQuery, GetDcrListQueryVariables>(
		GetDcrListDocument,
		options
	);
}
export function useGetDcrListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetDcrListQuery,
		GetDcrListQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetDcrListQuery, GetDcrListQueryVariables>(
		GetDcrListDocument,
		options
	);
}
export function useGetDcrListSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetDcrListQuery, GetDcrListQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetDcrListQuery, GetDcrListQueryVariables>(
		GetDcrListDocument,
		options
	);
}
export type GetDcrListQueryHookResult = ReturnType<typeof useGetDcrListQuery>;
export type GetDcrListLazyQueryHookResult = ReturnType<
	typeof useGetDcrListLazyQuery
>;
export type GetDcrListSuspenseQueryHookResult = ReturnType<
	typeof useGetDcrListSuspenseQuery
>;
export type GetDcrListQueryResult = Apollo.QueryResult<
	GetDcrListQuery,
	GetDcrListQueryVariables
>;
